import { z } from 'zod'
import { UserOrgDto } from './UserOrgDto'
import { OrgDto } from '../../org/models/OrgDto'
import { RoleDto } from '../../role/models/RoleDto'

export const UserOrgWithOrgDtoSchema = UserOrgDto.entitySchema
   .pick({
      orgId: true,
      roleId: true,
      userId: true,
      inviteSentOn: true,
      permissions: true,
   })
   .merge(
      z.object({
         roleName: RoleDto.entitySchema.shape.name,
         advisorOrg: OrgDto.minimalSchema.optional(),
         userOrgIsDeactivated: z.boolean().optional(),
         isGuest: z.boolean(),
         orgEntity: OrgDto.entitySchema.optional(),
         userOrg: UserOrgDto.entitySchema.optional(),
         orgSize: OrgDto.entitySchema.shape.orgSize.optional(),
      })
   )
   .merge(OrgDto.minimalSchema)

export type UserOrgWithOrgDto = z.output<typeof UserOrgWithOrgDtoSchema>
